interface Props {
  label?: string;
  className?: string;
}

export default function LoadingSpinner({ label = "正在加载更多资讯…", className = "" }: Props) {
  return (
    <div className={`w-full flex items-center justify-center gap-3 py-8 ${className}`} role="status">
      <span className="w-5 h-5 rounded-full border-2 border-background-300 border-t-primary-500 animate-spin inline-block" />
      <span className="text-sm text-foreground-600">{label}</span>
    </div>
  );
}